import type { Strand } from "../../models/caster.models";

export const isStrandLossPendingReason = (strand: Strand): boolean =>
  strand.StrandLossIsReasonPending === true;

export const getStrandsPendingLossReason = (strands: Strand[]): Strand[] =>
  strands.filter(isStrandLossPendingReason);
